module.exports = ".page-footer {\n  bottom: 0; }\n"